<template>
    <v-container class="text-left text-white site-content ramp-breadcrumbs-container px-8" v-if="isVisible">
        <!--h1 class="text-left ramp-breadcrumbs-header">{{ currentPath }}</h1-->
        <v-breadcrumbs :items="breadcrumbsPaths" class="mt-10"></v-breadcrumbs>
    </v-container>
</template>
<script lang="js">
export default {
  data() {
    return {
        isVisible: true,
        breadcrumbsPaths: [],
        paths: this.$route.path,
        currentPath: '',
    }
  },
  methods: {
    configureBreadcrumbs()
    {
        const fullPath=this.paths;
        let spreadPath = [];
        const breadcrumbsPathing = [];
        // Put BreadCrumb on Invisible if Path is /
        if(fullPath === '/')
        {
            this.isVisible = false;
        }
        spreadPath=fullPath.split("/");
        spreadPath[0] = 'home';
        let newPath = '';
        spreadPath.forEach(path => {
            if(path=='home'){
                newPath = '/';
            }
            else{
                newPath = '/'+path;
            }
            breadcrumbsPathing.push({
                title: path.replaceAll('-', ' '),
                href: newPath,
            });
        });
        this.currentPath = spreadPath[spreadPath.length - 1].replaceAll('-', ' ');
        this.breadcrumbsPaths = breadcrumbsPathing;
    }
  },
  mounted(){
    this.configureBreadcrumbs();
  }
}
</script>
<style scoped>
    .ramp-breadcrumbs-header
    {
        margin-top:30px;
        text-transform: capitalize;
        font-size:48px;
    }
    .v-breadcrumbs{
        text-transform: capitalize;
        padding:0;
        font-size:16px;
    }
    .ramp-breadcrumbs-container
    {
        padding-top:90px;
        padding-bottom:30px;
        background-image:linear-gradient(#002B44, #54AFCB);
    }
</style>